import React, { useEffect, useState } from "react";
import { Trash2, Mail, Check } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

export default function AdminMessages() {
  const [list, setList] = useState([]);
  const load = async () => setList((await api.get("/admin/messages")).data);
  useEffect(() => { load(); }, []);

  const toggleRead = async (m) => { await api.put(`/admin/messages/${m.id}/read`, null, { params: { read: !m.read } }); load(); };
  const remove = async (id) => { if (!confirm("Silinsin mi?")) return; await api.delete(`/admin/messages/${id}`); load(); };

  return (
    <div data-testid="admin-messages">
      <h1 className="font-heading text-4xl">Mesajlar</h1>
      <p className="text-larc-muted mt-1">İletişim formundan gelen mesajlar.</p>

      <div className="mt-8 space-y-3">
        {list.length === 0 ? (
          <div className="bg-white border border-larc-border rounded-2xl p-10 text-center text-larc-muted">Mesaj yok</div>
        ) : list.map((m) => (
          <div key={m.id} className={`bg-white border rounded-2xl p-5 ${m.read ? "border-larc-border" : "border-larc-gold/50 bg-larc-gold/5"}`} data-testid={`msg-${m.id}`}>
            <div className="flex items-start justify-between gap-4">
              <div className="flex items-start gap-3">
                <div className="h-10 w-10 rounded-full bg-larc-alt inline-flex items-center justify-center text-larc-gold"><Mail size={16} /></div>
                <div>
                  <div className="font-medium">{m.name} <span className="text-larc-muted text-sm ml-1">· {m.email}</span></div>
                  <div className="text-xs text-larc-muted mt-0.5">{m.subject || "—"} · {new Date(m.created_at).toLocaleString("tr-TR")}</div>
                  <p className="text-sm mt-3 leading-relaxed">{m.message}</p>
                </div>
              </div>
              <div className="flex flex-col gap-2 items-end">
                <button onClick={() => toggleRead(m)} className="text-xs uppercase tracking-[0.15em] inline-flex items-center gap-1.5 text-larc-muted hover:text-larc-ink"><Check size={14} /> {m.read ? "Okunmadı yap" : "Okundu"}</button>
                <button onClick={() => remove(m.id)} className="text-xs uppercase tracking-[0.15em] inline-flex items-center gap-1.5 text-larc-muted hover:text-red-600"><Trash2 size={14} /> Sil</button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
